import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/laboratory/:id',
  title: 'Editar Laboratório',
  endpoint: '/app/company',
}
